import React, { KeyboardEvent, MutableRefObject } from 'react';
import { Button, Icon, SearchField } from '@gerdau/hefesto';
import { ISearchResult } from '@gerdau/hefesto/SearchField/SearchField.types';
import { Chips } from '@gerdau/hefesto-mais-web';
import PaymentTermsInfo from '../../components/Purchase/Filters/PaymentTermsInfo';
import {
  SearchAndFiltersSection,
  SearchRow,
  FiltersRow,
  FilterGroup,
  FilterLabel,
  SearchResultText
} from './styles';
import { MaterialCode } from './useFavorites';

const MATERIAL_CODE_CHIPS = [
  { id: 'gerdauCode', label: 'Código de material Gerdau' },
  { id: 'internalCode', label: 'Código interno' }
];

interface FavoritesSearchBarProps {
  searchInput: string;
  suggestions: ISearchResult[];
  searchRef: MutableRefObject<HTMLInputElement | null>;
  paymentCondition: string | undefined;
  materialCode: MaterialCode;
  submittedSearch: string;
  total: number;
  setMaterialCode: (code: MaterialCode) => void;
  handleSearch: () => void;
  handleClearSearch: () => void;
  handleKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  handleSelectSuggestion: (result: ISearchResult) => void;
  handleSearchInputChange: (value: string) => void;
}

const FavoritesSearchBar: React.FC<FavoritesSearchBarProps> = ({
  searchInput,
  suggestions,
  searchRef,
  paymentCondition,
  materialCode,
  submittedSearch,
  total,
  setMaterialCode,
  handleSearch,
  handleClearSearch,
  handleKeyDown,
  handleSelectSuggestion,
  handleSearchInputChange
}) => (
  <SearchAndFiltersSection>
    <SearchRow>
      <SearchField
        ref={searchRef}
        label=""
        name="search-favoritos"
        placeholder="Busque nos Favoritos pela descrição técnica ou código do material"
        inputValue={searchInput}
        onChange={(e) => handleSearchInputChange(e.target.value)}
        onKeyDown={handleKeyDown}
        searchResultOptions={searchInput.length > 2 ? suggestions : undefined}
        onSelectResultOption={handleSelectSuggestion}
        hideLabel
      />
      <Button
        name="btn-buscar-favoritos"
        variant="primary"
        onClick={handleSearch}
        icon={<Icon option="Search" size="xs" />}
      >
        Buscar
      </Button>
      <Button
        name="btn-limpar-busca-favoritos"
        variant="secondary"
        onClick={handleClearSearch}
        style={{ visibility: submittedSearch ? 'visible' : 'hidden' }}
      >
        Limpar busca
      </Button>
    </SearchRow>
    <FiltersRow>
      <FilterGroup>
        <FilterLabel>Código de material</FilterLabel>
        <Chips
          type="choice"
          chips={MATERIAL_CODE_CHIPS}
          selectedChipIds={[materialCode]}
          handleSelect={(ids) => {
            if (ids.length > 0) {
              setMaterialCode(ids[0] as MaterialCode);
            }
          }}
        />
      </FilterGroup>
      {paymentCondition && (
        <FilterGroup>
          <PaymentTermsInfo paymentCondition={paymentCondition} />
        </FilterGroup>
      )}
    </FiltersRow>
    {submittedSearch && total > 0 && (
      <SearchResultText>
        Busca por <strong>&quot;{submittedSearch}&quot;</strong> retornou{' '}
        <b>{total}</b> resultado{total !== 1 ? 's' : ''} nos Favoritos:
      </SearchResultText>
    )}
  </SearchAndFiltersSection>
);

export default FavoritesSearchBar;
